export function getMsgToolTip(id_msg) {
    let _msg = ''
    if (id_msg == 1){ //Risco de Frustração
        _msg = "Risco de Frustração é uma medida de risco que indica o quanto o Benefício Estimado % do Salário está distante do salário atual. Risco ALTO indica situação delicada e sugere AUMENTO da contribuição atual, e/ou APORTE, e/ou AUMENTO na Idade de Aposentadoria."
    }
    return _msg
}    

